import React, { Component } from 'react'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'
import If from "../../common/control/If";

class AdfitPCForm extends Component {

    validate(setting) {
        if (setting.adfitPCTopType === 'none' && setting.adfitPCBottomType === 'none' && setting.adfitPCSidebarType === 'none')
            return false;
        if (setting.adfitPCTopType !== 'none' && !setting.adfitTopAd)
            return false;
        if (setting.adfitPCBottomType !== 'none' && !setting.adfitBottomAd)
            return false;
        if (setting.adfitPCSidebarType !== 'none' && !setting.adfitSidebarAd)
            return false;

        return true;
    }

    componentDidMount() {
        const { onChange } = this.props;
        let setting = {
            adfitPCTopType: this.props.data.setting.adfitPCTopType?this.props.data.setting.adfitPCTopType:(this.props.data.setting.adfitPCType?this.props.data.setting.adfitPCType:'none'),
            adfitPCBottomType: this.props.data.setting.adfitPCBottomType?this.props.data.setting.adfitPCBottomType:'none',
            adfitPCSidebarType: this.props.data.setting.adfitPCSidebarType?this.props.data.setting.adfitPCSidebarType:'none',
            adfitTopAd : this.props.data.setting.adfitTopAd?this.props.data.setting.adfitTopAd:(this.props.data.setting.adfitAd?this.props.data.setting.adfitAd:''),
            adfitBottomAd: this.props.data.setting.adfitBottomAd?this.props.data.setting.adfitBottomAd:'',
            adfitSidebarAd: this.props.data.setting.adfitSidebarAd?this.props.data.setting.adfitSidebarAd:'',
        };

        onChange(
            Object.assign({},  this.props.data, {
                setting: setting,
                validated: this.validate(setting)
            })
        )
    }

    @autobind
    handleADCodeChange(type, ADCode) {
        const { onChange } = this.props;
        var newObject = Object();
        newObject[type] = ADCode;
        let setting = Object.assign({},  this.props.data.setting, newObject);
        onChange(
            Object.assign({},  this.props.data, {
                setting: setting,
                validated: this.validate(setting)
            })
        )
    }

    @autobind
    handleAdfitTopTypeChange(AdfitType) {

        const { onChange } = this.props;
        let setting = Object.assign({},  this.props.data.setting, {
            adfitPCTopType: AdfitType
        });
        onChange(
            Object.assign({},  this.props.data, {
                setting: setting,
                validated: this.validate(setting)
            })
        )
    }
    @autobind
    handleAdfitBottomTypeChange(AdfitType) {

        const { onChange } = this.props;
        let setting = Object.assign({},  this.props.data.setting, {
            adfitPCBottomType: AdfitType
        });
        onChange(
            Object.assign({},  this.props.data, {
                setting: setting,
                validated: this.validate(setting)
            })
        )
    }
    @autobind
    handleAdfitSidebarTypeChange(AdfitType) {

        const { onChange } = this.props;
        let setting = Object.assign({},  this.props.data.setting, {
            adfitPCSidebarType: AdfitType
        });
        onChange(
            Object.assign({},  this.props.data, {
                setting: setting,
                validated: this.validate(setting)
            })
        )
    }

    render() {
        const { plugin, data } = this.props;

        return (
        <div className="desc_plugin7">
            <p className="txt_plugin" dangerouslySetInnerHTML={{ __html: plugin.rawDescription }} />
            <div className="info_pluginline">
                <strong className="tit_set">설정 방법</strong>
                <ol className="list_plugin">
                    <li>
                        <span className="txt_em">1</span>
                        광고 배치 유형 중 1개를 선택해 주세요.(상단/하단/측면 각각 1개씩 선택 가능)
                    </li>
                    <li>
                        <span className="txt_em">2</span>
                        광고 코드 입력창에 AdFit 광고 코드를 넣어주세요.<a href="http://adfit.biz.daum.net" target="_blank" className="link_other">AdFit 바로가기</a>
                    </li>
                    <li>
                        <span className="txt_em">3</span>
                        적용 버튼을 누르면 설정이 완료됩니다.
                    </li>
                </ol>
            </div>
            <fieldset>
                <legend className="tit_set">상단 광고</legend>
                <div className="list_google">
                    <label className="lab_google">
                        <input type="radio" name="plugin1" className="inp_set" checked={data.setting.adfitPCTopType === "topRight"} onChange={(e)=>this.handleAdfitTopTypeChange('topRight')}/>
                        <span className="ico_google ico_google1">상단 우측</span>
                    </label>
                    <label className="lab_google">
                        <input type="radio" name="plugin1" className="inp_set" checked={data.setting.adfitPCTopType === "topLeft"} onChange={(e)=>this.handleAdfitTopTypeChange('topLeft')}/>
                        <span className="ico_google ico_google2">상단 좌측</span>
                    </label>
                    <label className="lab_google">
                        <input type="radio" name="plugin1" className="inp_set" checked={data.setting.adfitPCTopType === "topCenter"} onChange={(e)=>this.handleAdfitTopTypeChange('topCenter')}/>
                        <span className="ico_google ico_google3">상단 전체</span>
                    </label>
                    <label className="lab_google">
                        <input type="radio" name="plugin1" className="inp_set" checked={data.setting.adfitPCTopType === "none"} onChange={(e)=>this.handleAdfitTopTypeChange('none')}/>
                        <span className="ico_google ico_google4">광고 없음</span>
                    </label>
                </div>
                <If condition={data.setting.adfitPCTopType === "topRight" || data.setting.adfitPCTopType === "topLeft"} >
                        <textarea className="tf_blog" title="광고 코드 입력"
                                  placeholder="300X250, 250X250 크기의 AdFit 광고 코드만 넣을 수 있습니다."
                                  onChange={(e)=>this.handleADCodeChange('adfitTopAd', e.target.value)}>{data.setting.adfitTopAd}</textarea>
                </If>
                <If condition={data.setting.adfitPCTopType === "topCenter"} >
                        <textarea className="tf_blog" title="광고 코드 입력"
                                  placeholder="728X90 크기의 AdFit 광고 코드만 넣을 수 있습니다."
                                  onChange={(e)=>this.handleADCodeChange('adfitTopAd', e.target.value)}>{data.setting.adfitTopAd}</textarea>
                </If>
            </fieldset>
            <fieldset>
                <legend className="tit_set">하단 광고</legend>
                <div className="list_google">
                    <label className="lab_google">
                        <input type="radio" name="plugin2" className="inp_set" checked={data.setting.adfitPCBottomType === "bottomCenter"} onChange={(e)=>this.handleAdfitBottomTypeChange('bottomCenter')}/>
                        <span className="ico_google ico_google5">하단 전체</span>
                    </label>
                    <label className="lab_google">
                        <input type="radio" name="plugin2" className="inp_set" checked={data.setting.adfitPCBottomType === "none"} onChange={(e)=>this.handleAdfitBottomTypeChange('none')}/>
                        <span className="ico_google ico_google7">광고 없음</span>
                    </label>
                </div>
                {data.setting.adfitPCBottomType === "bottomCenter" && (
                    <textarea className="tf_blog" title="광고 코드 입력"
                              placeholder="728X90 크기의 AdFit 광고 코드만 넣을 수 있습니다."
                              onChange={(e)=>this.handleADCodeChange('adfitBottomAd', e.target.value)}
                              value={data.setting.adfitBottomAd}>
                    </textarea>
                )}
            </fieldset>
            <fieldset>
                <legend className="tit_set">사이드바 광고</legend>
                <div className="list_google">
                    <label className="lab_google">
                        <input type="radio" name="plugin3" className="inp_set" checked={data.setting.adfitPCSidebarType === "skyscraper160x600"} onChange={(e)=>this.handleAdfitSidebarTypeChange('skyscraper160x600')}/>
                        <span className="ico_adfitpc ico_adfitpc1">사이드바 광고</span>
                    </label>
                    <label className="lab_google">
                        <input type="radio" name="plugin3" className="inp_set" checked={data.setting.adfitPCSidebarType === "none"} onChange={(e)=>this.handleAdfitSidebarTypeChange('none')}/>
                        <span className="ico_adfitpc ico_adfitpc2">광고 없음</span>
                    </label>
                </div>
                {data.setting.adfitPCSidebarType === "skyscraper160x600" && (
                    <textarea className="tf_blog" title="광고 코드 입력"
                              placeholder="사이드바 영역에 적합한 광고입니다.160X600 크기의 AdFit 광고 코드만 넣을 수 있습니다. 코드를 적용하신 후 꾸미기 ­– 사이드바에서 모듈 설정이 필요합니다."
                              onChange={(e)=>this.handleADCodeChange('adfitSidebarAd', e.target.value)}
                              value={data.setting.adfitSidebarAd} />
                )}
            </fieldset>
            {this.props.saveButton()}
        </div>
        )
    }
}

AdfitPCForm.propTypes = {
    plugin: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
};

export default AdfitPCForm
